import React from 'react';
import { ReactComponent as GA } from '@svg/ga.svg';
import { ReactComponent as AM } from '@svg/am.svg';
import { ReactComponent as MP } from '@svg/mp.svg';
import { ReactComponent as FB_CUSTOM_AUDIENCE, ReactComponent as FB } from '@svg/fb.svg';

import { ReactComponent as FACEBOOK_PIXEL } from '@svg/facebook_pixel.svg';
import { ReactComponent as ADJ } from '@svg/adj.svg';
import { ReactComponent as Hubspot } from '@svg/hs.svg';
import { ReactComponent as S3 } from '@svg/s3.svg';
import { ReactComponent as GCS } from '@svg/gcs.svg';
import { ReactComponent as MINIO } from '@svg/minio.svg';
import { ReactComponent as RS } from '@svg/redshift.svg';
import { ReactComponent as MSSQL } from '@svg/mssql.svg';
import { ReactComponent as BQ } from '@svg/bigquery.svg';
import { ReactComponent as SNOWFLAKE } from '@svg/snowflake.svg';
import { ReactComponent as POSTGRES } from '@svg/postgres.svg';
import { ReactComponent as CLICKHOUSE } from '@svg/clickhouse.svg';
import { ReactComponent as AF } from '@svg/af.svg';
import { ReactComponent as MAILCHIMP } from '@svg/mailchimp.svg';
import { ReactComponent as HOTJAR } from '@svg/hotjar.svg';
import { ReactComponent as SALESFORCE } from '@svg/salesforce.svg';
import { ReactComponent as SEGMENT } from '@svg/segment.svg';
import { ReactComponent as AUTOPILOT } from '@svg/autopilot.svg';
import { ReactComponent as GOOGLEADS } from '@svg/googleads.svg';
import { ReactComponent as AZURE_BLOB } from '@svg/azure_blob.svg';
import { ReactComponent as VWO } from '@svg/vwo.svg';
import { ReactComponent as INTERCOM } from '@svg/intercom.svg';
import { ReactComponent as HEAP } from '@svg/heap.svg';
import { ReactComponent as BRANCH } from '@svg/branch.svg';
import { ReactComponent as KOCHAVA } from '@svg/kochava.svg';
import { ReactComponent as GTM } from '@svg/gtm.svg';
import { ReactComponent as BRAZE } from '@svg/braze.svg';
import { ReactComponent as KEEN } from '@svg/keen.svg';
import { ReactComponent as KISSMETRICS } from '@svg/kissmetrics.svg';
import { ReactComponent as CUSTOMERIO } from '@svg/customerio.svg';
import { ReactComponent as CHARTBEAT } from '@svg/chartbeat.svg';
import { ReactComponent as FIREBASE } from '@svg/firebase.svg';
import { ReactComponent as LEANPLUM } from '@svg/leanplum.svg';
import { ReactComponent as FULLSTORY } from '@svg/fullstory.svg';
import { ReactComponent as WEBHOOK } from '@svg/webhook.svg';
import { ReactComponent as PERSONALIZE } from '@svg/Personalize.svg';
import { ReactComponent as BUGSNAG } from '@svg/bugsnag.svg';
import { ReactComponent as LOTAME, ReactComponent as LOTAME_MOBILE } from '@svg/lotame.svg';
import { ReactComponent as ATTRIBUTION } from '@svg/attribution.svg';
import { ReactComponent as SLACK } from '@svg/sidebar_slack.svg';
import { ReactComponent as KINESIS } from '@svg/kinesis.svg';
import { ReactComponent as ZENDESK } from '@svg/zendesk.svg';
import { ReactComponent as KAFKA } from '@svg/kafka.svg';
import { ReactComponent as AZURE_EVENT_HUB } from '@svg/azure_event_hub.svg';
import { ReactComponent as AZURE_SYNAPSE } from '@svg/azure_synapse.svg';
import { ReactComponent as ITERABLE } from '@svg/Iterable.svg';
import { ReactComponent as FIREHOSE } from '@svg/firehose.svg';
import { ReactComponent as EVENTBRIDGE } from '@svg/eventbridge.svg';
import { ReactComponent as DIGITAL_OCEAN_SPACES } from '@svg/digital_ocean_spaces.svg';
import { ReactComponent as INDICATIVE } from '@svg/indicative.svg';
import {
  ReactComponent as OPTIMIZELY,
  ReactComponent as OPTIMIZELY_FULLSTACK,
} from '@svg/Optimizely.svg';

import { ReactComponent as GOOGLEPUBSUB } from '@svg/googlepubsub.svg';
import { ReactComponent as MONETATE } from '@svg/monetate.svg';
import { ReactComponent as TVSQUARED } from '@svg/tvsquared.svg';
import { ReactComponent as LYTICS } from '@svg/lytics.svg';
import { ReactComponent as DRIFT } from '@svg/drift.svg';
import { ReactComponent as MARKETO, ReactComponent as MARKETO_BULK_UPLOAD } from '@svg/marketo.svg';

import { ReactComponent as PARDOT } from '@svg/salesforce-pardot.svg';
import { ReactComponent as TWITTER } from '@svg/twitter.svg';
import { ReactComponent as TAPLYTICS } from '@svg/taplytics.svg';
import { ReactComponent as ADOBE_ANALYTICS } from '@svg/adobe_analytics.svg';
import { ReactComponent as REDIS } from '@svg/redis.svg';
import { ReactComponent as MOENGAGE } from '@svg/MoEngage.svg';
import { ReactComponent as POSTHOG } from '@svg/posthog.svg';
import { ReactComponent as CONFLUENT_CLOUD } from '@svg/confluent_cloud.svg';
import { ReactComponent as PENDO } from '@svg/pendo.svg';
import { ReactComponent as APPCUES } from '@svg/appcues.svg';
import { ReactComponent as USERLIST } from '@svg/userlist.svg';
import { ReactComponent as APPCENTER } from '@svg/appcenter.svg';
import { ReactComponent as ACTIVE_CAMPAIGN } from '@svg/active_campaign.svg';
import { ReactComponent as KLAVIYO } from '@svg/klaviyo.svg';
import { ReactComponent as CLEVERTAP } from '@svg/clever_tap.svg';
import { ReactComponent as KUSTOMER } from '@svg/kustomer.svg';
import { ReactComponent as BINGADS } from '@svg/bingads.svg';
import { ReactComponent as GOOGLESHEETS } from '@svg/googlesheets.svg';
import { ReactComponent as PINTEREST_TAG } from '@svg/pinterest_tag.svg';
import { ReactComponent as SPLITIO } from '@svg/splitio.svg';
import { ReactComponent as PIPEDRIVE } from '@svg/pipedrive.svg';
import { ReactComponent as GAINSIGHT } from '@svg/gainsight_cs.svg';
import { ReactComponent as RECURLY } from '@svg/recurly.svg';
import { ReactComponent as TRENGO } from '@svg/trengo.svg';
import { ReactComponent as LINKEDIN_INSIGHT_TAG } from '@svg/linkedin_ads.svg';
import { ReactComponent as VARIANCE } from '@svg/variance.svg';
import { ReactComponent as GAINSIGHT_PX } from '@svg/gainsight_px.svg';
import { ReactComponent as CRITEO } from '@svg/criteo.svg';
import { ReactComponent as REDDIT_PIXEL } from '@svg/reddit_pixel.svg';
import { ReactComponent as DELIGHTED } from '@svg/delighted.svg';
import { ReactComponent as SNAP_PIXEL } from '@svg/snap_pixel.svg';
import { ReactComponent as DRIP } from '@svg/drip.svg';
import { ReactComponent as QUALTRICS } from '@svg/qualtrics.svg';
import { ReactComponent as OMETRIA } from '@svg/ometria.svg';
import { ReactComponent as SENTRY } from '@svg/sentry.svg';
import { ReactComponent as PROFITWELL } from '@svg/profitwell.svg';
import { ReactComponent as ALGOLIA } from '@svg/algolia.svg';
import { ReactComponent as AWIN } from '@svg/awin.svg';
import { ReactComponent as SENDGRID } from '@svg/sendgrid.svg';
import { ReactComponent as DELTALAKE } from '@svg/deltalake.svg';
import { ReactComponent as GOOGLE_OPTIMIZE } from '@svg/google_optimize.svg';
import { ReactComponent as STATSIG } from '@svg/statsig.svg';
import { ReactComponent as TIKTOK_ADS } from '@svg/tiktok_ads.svg';
import { ReactComponent as POST_AFFILIATE_PRO } from '@svg/post_affiliate_pro.svg';
import { ReactComponent as LAUNCHDARKLY } from '@svg/launchdarkly.svg';
import { ReactComponent as CANDU } from '@svg/candu.svg';
// Use the destination icon name as mentioned in backend.
import { ReactComponent as COMSCORE } from '@svg/comscore.svg';
import { ReactComponent as QUANTUMMETRIC } from '@svg/quantummetric.svg';
import { ReactComponent as SINGULAR } from '@svg/singular.svg';
import { ReactComponent as BLUESHIFT } from '@svg/blueshift.svg';
import { ReactComponent as AIRSHIP } from '@svg/airship.svg';
import { ReactComponent as SNAPCHAT_CONVERSION } from '@svg/snapchat_conversion.svg';
import { ReactComponent as DCM_FLOODLIGHT } from '@svg/dcm_floodlight.svg';
import { ReactComponent as ADROLL } from '@svg/adroll.svg';
import { ReactComponent as NEW_RELIC } from '@svg/new_relic.svg';
import { ReactComponent as REVENUE_CAT } from '@svg/revenue_cat.svg';
import { ReactComponent as ATTENTIVE_TAG } from '@svg/attentive_tag.svg';
import { ReactComponent as YAHOO_DSP } from '@svg/yahoo_dsp.svg';
import { ReactComponent as WEBENGAGE } from '@svg/webengage.svg';
import { ReactComponent as VERO } from '@svg/vero.svg';
import { ReactComponent as MATOMO } from '@svg/matomo.svg';
import { ReactComponent as ONE_SIGNAL } from '@svg/one_signal.svg';
import { ReactComponent as MOUSEFLOW } from '@svg/mouseflow.svg';
import { ReactComponent as CANNY } from '@svg/canny.svg';
import theme from '@css/theme';

// Use the destination icon name as mentioned in backend.

interface DestIconProps extends React.SVGAttributes<unknown> {
  destination?: string;
  width?: number | 'string';
  height?: number | 'string';
}

const DestinationIcon = ({ destination = '', width, height, ...restProps }: DestIconProps) => {
  // Making medium size default.
  height = height || theme.iconSize.medium;
  width = width || theme.iconSize.medium;
  switch (destination.toLowerCase()) {
    case 'am':
      return <AM width={width} height={height} {...restProps} />;
    case 'ga':
    case 'ga4':
    case 'ga360':
      return <GA width={width} height={height} />;
    case 'mp':
      return <MP width={width} height={height} {...restProps} />;
    case 'fb_custom_audience':
      return <FB_CUSTOM_AUDIENCE width={width} height={height} {...restProps} />;
    case 'fb':
      return <FB width={width} height={height} {...restProps} />;
    case 'facebook_pixel':
      return <FACEBOOK_PIXEL width={width} height={height} {...restProps} />;
    case 'adj':
      return <ADJ width={width} height={height} {...restProps} />;
    case 'hs':
      return <Hubspot width={width} height={height} {...restProps} />;
    case 's3':
      return <S3 width={width} height={height} {...restProps} />;
    case 'gcs':
      return <GCS width={width} height={height} {...restProps} />;
    case 'minio':
      return <MINIO width={width} height={height} {...restProps} />;
    case 'rs':
      return <RS width={width} height={height} {...restProps} />;
    case 'mssql':
      return <MSSQL width={width} height={height} {...restProps} />;
    case 'azure_synapse':
      return <AZURE_SYNAPSE width={width} height={height} {...restProps} />;
    case 'bqstream':
    case 'bq':
      return <BQ width={width} height={height} {...restProps} />;
    case 'snowflake':
      return <SNOWFLAKE width={width} height={height} {...restProps} />;
    case 'postgres':
      return <POSTGRES width={width} height={height} {...restProps} />;
    case 'clickhouse':
      return <CLICKHOUSE width={width} height={height} {...restProps} />;
    case 'af':
      return <AF width={width} height={height} {...restProps} />;
    case 'mailchimp':
      return <MAILCHIMP width={width} height={height} {...restProps} />;
    case 'hotjar':
      return <HOTJAR width={width} height={height} {...restProps} />;
    case 'salesforce':
      return <SALESFORCE width={width} height={height} {...restProps} />;
    case 'sfmc':
      return <SALESFORCE width={width} height={height} {...restProps} />;
    case 'segment':
      return <SEGMENT width={width} height={height} {...restProps} />;
    case 'autopilot':
      return <AUTOPILOT width={width} height={height} {...restProps} />;
    case 'googleads':
    case 'google_ads_classic':
    case 'google_adwords_remarketing_lists':
    case 'google_adwords_enhanced_conversions':
      return <GOOGLEADS width={width} height={height} {...restProps} />;
    case 'azure_blob':
      return <AZURE_BLOB width={width} height={height} {...restProps} />;
    case 'vwo':
      return <VWO width={width} height={height} {...restProps} />;
    case 'intercom':
      return <INTERCOM width={width} height={height} {...restProps} />;
    case 'heap':
      return <HEAP width={width} height={height} {...restProps} />;
    case 'branch':
      return <BRANCH width={width} height={height} {...restProps} />;
    case 'gtm':
      return <GTM width={width} height={height} {...restProps} />;
    case 'braze':
      return <BRAZE width={width} height={height} {...restProps} />;
    case 'keen':
      return <KEEN width={width} height={height} {...restProps} />;
    case 'klaviyo':
      return <KLAVIYO width={width} height={height} {...restProps} />;
    case 'kochava':
      return <KOCHAVA width={width} height={height} {...restProps} />;
    case 'kissmetrics':
      return <KISSMETRICS width={width} height={height} {...restProps} />;
    case 'customerio':
      return <CUSTOMERIO width={width} height={height} {...restProps} />;
    case 'chartbeat':
      return <CHARTBEAT width={width} height={height} {...restProps} />;
    case 'fullstory':
      return <FULLSTORY width={width} height={height} {...restProps} />;
    case 'firebase':
      return <FIREBASE width={width} height={height} {...restProps} />;
    case 'leanplum':
      return <LEANPLUM width={width} height={height} {...restProps} />;
    case 'webhook':
      return <WEBHOOK width={width} height={height} {...restProps} />;
    case 'personalize':
      return <PERSONALIZE width={width} height={height} {...restProps} />;
    case 'profitwell':
      return <PROFITWELL width={width} height={height} {...restProps} />;
    case 'lotame_mobile':
      return <LOTAME_MOBILE width={width} height={height} {...restProps} />;
    case 'lotame':
      return <LOTAME width={width} height={height} {...restProps} />;
    case 'slack':
      return <SLACK width={width} height={height} {...restProps} />;
    case 'bugsnag':
      return <BUGSNAG width={width} height={height} {...restProps} />;
    case 'kinesis':
      return <KINESIS width={width} height={height} {...restProps} />;
    case 'zendesk':
      return <ZENDESK width={width} height={height} {...restProps} />;
    case 'kafka':
      return <KAFKA width={width} height={height} {...restProps} />;
    case 'azure_event_hub':
      return <AZURE_EVENT_HUB width={width} height={height} {...restProps} />;
    case 'iterable':
      return <ITERABLE width={width} height={height} {...restProps} />;
    case 'firehose':
      return <FIREHOSE width={width} height={height} {...restProps} />;
    case 'eventbridge':
      return <EVENTBRIDGE width={width} height={height} {...restProps} />;
    case 'digital_ocean_spaces':
      return <DIGITAL_OCEAN_SPACES width={width} height={height} {...restProps} />;
    case 'indicative':
      return <INDICATIVE width={width} height={height} {...restProps} />;
    case 'optimizely':
      return <OPTIMIZELY width={width} height={height} {...restProps} />;
    case 'optimizely_fullstack':
      return <OPTIMIZELY_FULLSTACK width={width} height={height} {...restProps} />;
    case 'googlepubsub':
      return <GOOGLEPUBSUB width={width} height={height} {...restProps} />;
    case 'monetate':
      return <MONETATE width={width} height={height} {...restProps} />;
    case 'tvsquared':
      return <TVSQUARED width={width} height={height} {...restProps} />;
    case 'drift':
      return <DRIFT width={width} height={height} {...restProps} />;
    case 'marketo':
      return <MARKETO width={width} height={height} {...restProps} />;
    case 'marketo_bulk_upload':
      return <MARKETO_BULK_UPLOAD width={width} height={height} {...restProps} />;
    case 'pardot':
      return <PARDOT width={width} height={height} {...restProps} />;
    case 'twitter_ads':
      return <TWITTER width={width} height={height} {...restProps} />;
    case 'taplytics':
      return <TAPLYTICS width={width} height={height} {...restProps} />;
    case 'adobe_analytics':
      return <ADOBE_ANALYTICS width={width} height={height} {...restProps} />;
    case 'lytics':
      return <LYTICS width={width} height={height} {...restProps} />;
    case 'redis':
      return <REDIS width={width} height={height} {...restProps} />;
    case 'moengage':
      return <MOENGAGE width={width} height={height} {...restProps} />;
    case 'posthog':
      return <POSTHOG width={width} height={height} {...restProps} />;
    case 'confluent_cloud':
      return <CONFLUENT_CLOUD width={width} height={height} {...restProps} />;
    case 'pendo':
      return <PENDO width={width} height={height} {...restProps} />;
    case 'appcues':
      return <APPCUES width={width} height={height} {...restProps} />;
    case 'userlist':
      return <USERLIST width={width} height={height} {...restProps} />;
    case 'appcenter':
      return <APPCENTER width={width} height={height} {...restProps} />;
    case 'active_campaign':
      return <ACTIVE_CAMPAIGN width={width} height={height} {...restProps} />;
    case 'clevertap':
      return <CLEVERTAP width={width} height={height} {...restProps} />;
    case 'kustomer':
      return <KUSTOMER width={width} height={height} {...restProps} />;
    case 'bingads':
      return <BINGADS width={width} height={height} {...restProps} />;
    case 'comscore':
      return <COMSCORE width={width} height={height} {...restProps} />;
    case 'googlesheets':
      return <GOOGLESHEETS width={width} height={height} {...restProps} />;
    case 'pinterest_tag':
      return <PINTEREST_TAG width={width} height={height} {...restProps} />;
    case 'splitio':
      return <SPLITIO width={width} height={height} {...restProps} />;
    case 'trengo':
      return <TRENGO width={width} height={height} {...restProps} />;
    case 'pipedrive':
      return <PIPEDRIVE width={width} height={height} {...restProps} />;
    case 'linkedin_insight_tag':
      return <LINKEDIN_INSIGHT_TAG width={width} height={height} {...restProps} />;
    case 'gainsight':
      return <GAINSIGHT width={width} height={height} {...restProps} />;
    case 'recurly':
      return <RECURLY width={width} height={height} />;
    case 'variance':
      return <VARIANCE width={width} height={height} />;
    case 'gainsight_px':
      return <GAINSIGHT_PX width={width} height={height} {...restProps} />;
    case 'criteo':
      return <CRITEO width={width} height={height} {...restProps} />;
    case 'reddit_pixel':
      return <REDDIT_PIXEL width={width} height={height} {...restProps} />;
    case 'delighted':
      return <DELIGHTED width={width} height={height} {...restProps} />;
    case 'snap_pixel':
      return <SNAP_PIXEL width={width} height={height} {...restProps} />;
    case 'drip':
      return <DRIP width={width} height={height} {...restProps} />;
    case 'qualtrics':
      return <QUALTRICS width={width} height={height} {...restProps} />;
    case 'ometria':
      return <OMETRIA width={width} height={height} {...restProps} />;
    case 's3_datalake':
      return <S3 width={width} height={height} {...restProps} />;
    case 'algolia':
      return <ALGOLIA width={width} height={height} {...restProps} />;
    case 'awin':
      return <AWIN width={width} height={height} {...restProps} />;
    case 'sentry':
      return <SENTRY width={width} height={height} {...restProps} />;
    case 'quantummetric':
      return <QUANTUMMETRIC width={width} height={height} {...restProps} />;
    case 'sendgrid':
      return <SENDGRID width={width} height={height} {...restProps} />;
    case 'gcs_datalake':
      return <GCS width={width} height={height} {...restProps} />;
    case 'azure_datalake':
      return <AZURE_BLOB width={width} height={height} {...restProps} />;
    case 'deltalake':
      return <DELTALAKE width={width} height={height} {...restProps} />;
    case 'google_optimize':
      return <GOOGLE_OPTIMIZE width={width} height={height} {...restProps} />;
    case 'post_affiliate_pro':
      return <POST_AFFILIATE_PRO width={width} height={height} {...restProps} />;
    case 'statsig':
      return <STATSIG width={width} height={height} {...restProps} />;
    case 'launchdarkly':
      return <LAUNCHDARKLY width={width} height={height} {...restProps} />;
    case 'candu':
      return <CANDU width={width} height={height} {...restProps} />;
    case 'tiktok_ads':
      return <TIKTOK_ADS width={width} height={height} {...restProps} />;
    case 'singular':
      return <SINGULAR width={width} height={height} {...restProps} />;
    case 'blueshift':
      return <BLUESHIFT width={width} height={height} {...restProps} />;
    case 'airship':
      return <AIRSHIP width={width} height={height} {...restProps} />;
    case 'snapchat_conversion':
      return <SNAPCHAT_CONVERSION width={width} height={height} {...restProps} />;
    case 'dcm_floodlight':
      return <DCM_FLOODLIGHT width={width} height={height} {...restProps} />;
    case 'adroll':
      return <ADROLL width={width} height={height} {...restProps} />;
    case 'new_relic':
      return <NEW_RELIC width={width} height={height} {...restProps} />;
    case 'revenue_cat':
      return <REVENUE_CAT width={width} height={height} {...restProps} />;
    case 'attribution':
      return <ATTRIBUTION width={width} height={height} />;
    case 'attentive_tag':
      return <ATTENTIVE_TAG width={width} height={height} {...restProps} />;
    case 'webengage':
      return <WEBENGAGE width={width} height={height} {...restProps} />;
    case 'yahoo_dsp':
      return <YAHOO_DSP width={width} height={height} {...restProps} />;
    case 'vero':
      return <VERO width={width} height={height} {...restProps} />;
    case 'matomo':
      return <MATOMO width={width} height={height} {...restProps} />;
    case 'one_signal':
      return <ONE_SIGNAL width={width} height={height} {...restProps} />;
    case 'mouseflow':
      return <MOUSEFLOW width={width} height={height} {...restProps} />;
    case 'canny':
      return <CANNY width={width} height={height} {...restProps} />;
    default:
      break;
  }
  return <div />;
};

export default DestinationIcon;
